export default __webpack_public_path__ + "static/media/Djeco-Baby-Shaki-1.66e62f44.jpg";